import { supportedTimezones } from './supported-timezones';
import { ValidationErrorKeys } from './validation-erros-keys';

export const timezoneFn = (
	value: any, // eslint-disable-line @typescript-eslint/no-explicit-any
	forbiddenChars: string | Array<string>,
	timezoneSeparator = '%TZ'
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
): { [k: string]: any } | null => {
	let forbidden = [];
	if (!Array.isArray(forbiddenChars)) {
		forbidden = Array.from(forbiddenChars);
	} else {
		forbidden = forbiddenChars;
	}

	const [valueWithNoTimeZone, remainder] = value.split(timezoneSeparator);

	if (remainder) {
		const detectedTimezone = remainder.replace(/}/g, '');

		const timezone = detectedTimezone.replace(/[()]/g, '');

		if (timezone && !supportedTimezones.has(timezone)) {
			return {
				[ValidationErrorKeys.UnrecognizableTimezone]: true,
			};
		}
	}

	let hasForbiddenChar = false;
	// eslint-disable-next-line @typescript-eslint/prefer-for-of
	for (let i = 0; i < forbidden.length; i++) {
		hasForbiddenChar = (valueWithNoTimeZone as string).includes(forbidden[i]);
		if (hasForbiddenChar) {
			break;
		}
	}

	if (hasForbiddenChar) {
		return {
			[ValidationErrorKeys.ForbiddenCharacters]: true,
		};
	}
	return null;
};
